import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { SidebarService } from "@core/services/presenters/sidebar.service";
import { LogoBigComponent } from "@shared/design/atoms/logo/logo-big.component";
import { LogoSmallComponent } from "@shared/design/atoms/logo/logo-small.component";

@Component({
    selector: 'app-layout-sidebar-logo',
    imports: [CommonModule, LogoBigComponent, LogoSmallComponent],
    templateUrl: './layout-sidebar-logo.component.html'
})
  export class LayoutSidebarLogoComponent {
    constructor(readonly sidebarService: SidebarService) {}
  }
  